import useGlobalContext from "globalProviders/GlobalDataProvider";
import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "react-query";

type AuthData = {
  isAuthenticated: boolean;
};

const AuthContext = createContext<AuthData>({ isAuthenticated: false });

export const useAuthContext = () => useContext<AuthData>(AuthContext);

export type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { authenticationService } = useGlobalContext();

  const { data, isLoading } = useQuery(
    ["isAuthenticated"],
    () => authenticationService.isAuthenticated(),
    {
      staleTime: Infinity,
      retry: false,
    }
  );

  const authContextValue = useMemo(
    () => ({
      isAuthenticated: data?.data ?? false,
    }),
    [data?.data]
  );

  if (isLoading) {
    return null;
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};
